Object.defineProperty(exports, "__esModule", { value: true });
exports.parseProp = void 0;
const get_responsive_prop_1 = require("./get-responsive-prop");
exports.parseProp = ({ config, theme, name, value }) => {
    let parsedProp;
    let result;
    if (config.ignoreProperties.includes(name)) {
        return;
    }
    if (Array.isArray(value)) {
        parsedProp = value;
    }
    else {
        parsedProp = [value];
    }
    Object.entries(config.stringMaps).forEach(([stringMapName, stringMapProperties]) => {
        if (stringMapProperties.includes(name)) {
            const newArray = [];
            parsedProp.forEach((item) => {
                let newValue = item;
                if (typeof item === 'string') {
                    const stringMap = theme[stringMapName];
                    newValue = stringMap[item] || item;
                }
                newArray.push(newValue);
            });
            parsedProp = newArray;
        }
    });
    Object.entries(config.scales).forEach(([scaleName, scaleProperties]) => {
        if (scaleProperties.includes(name)) {
            const newArray = [];
            parsedProp.forEach((item) => {
                let newValue = item;
                if (Number.isInteger(item)) {
                    const scaleList = theme[scaleName];
                    if (item < 0) {
                        newValue = -scaleList[-item];
                    }
                    else {
                        newValue = scaleList[item];
                    }
                    if (item === 0 && config.initialZeroScales.includes(scaleName)) {
                        newValue = 'initial';
                    }
                }
                newArray.push(newValue);
            });
            parsedProp = newArray;
        }
    });
    Object.entries(config.units).forEach(([unit, unitProperties]) => {
        if (unitProperties.includes(name)) {
            const newArray = [];
            parsedProp.forEach((item) => {
                let newValue = item;
                if (typeof item === 'number') {
                    if (unit === 'percent') {
                        newValue *= 100;
                        newValue += '%';
                    }
                    else {
                        newValue += unit;
                    }
                }
                newArray.push(newValue);
            });
            parsedProp = newArray;
        }
    });
    if (config.responsiveProperties.includes(name)) {
        result = get_responsive_prop_1.getResponsiveProp({ theme, propName: name, propValue: parsedProp });
    }
    else {
        if (parsedProp.length > 1 && process.env.NODE_ENV !== 'test') {
            console.log(`WARNING: found unhandled responsive property '${name}'.
Using first value only. Consider adding this property to the
responsiveProperties config array`);
        }
        result = { [name]: parsedProp[0] };
    }
    return result;
};
//# sourceMappingURL=parse-prop.js.map